import { useMutation, gql } from "@apollo/client"
import { TASK_FIELDS } from "./useQueryOrganisationTemplates"

const UPDATE_TASK_MUTATION = gql`
  mutation UpdateTask(
    $id: ID!
    $name: String!
    $description: String
    $priority: Int
    $after: ScheduleDateInput
    $due: ScheduleDateInput    
    $pinned: Boolean
    $users: [ID!]
    $groups: [ID!]
    $locations: [ID!]!
  ) {
    updateTask(
      id: $id
      name: $name
      description: $description
      priority: $priority
      after: $after
      due: $due
      pinned: $pinned
      users: $users
      groups: $groups
      locations: $locations
    ) {
      ${TASK_FIELDS}
    }
  }
`

const UPDATETASK_INACTIVE_MUTATION = gql`
  mutation UpdateTaskInactive(
    $id: ID!
    $inactive: Boolean!
    ) {       
      updateTaskInactive(id: $id, inactive: $inactive) {
        ${TASK_FIELDS}
      } 
  }
`

const DELETETASK_MUTATION = gql`
  mutation DeleteTask($id: ID!) {
    deleteTask(id: $id)
  }
`

const useMutationUpdateTask = () => useMutation(UPDATE_TASK_MUTATION)

const useMutationUpdateTaskInactive = () => useMutation(UPDATETASK_INACTIVE_MUTATION)

const useMutationDeleteTask = () => useMutation(DELETETASK_MUTATION)

export { useMutationUpdateTask, useMutationUpdateTaskInactive, useMutationDeleteTask }
